module.exports = __webpack_public_path__ + "static/media/workPvcCeilings19.ad16aa55.jpg";